module.exports = "pegasus_template/assets/circleline-instagram.png";